import { Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { useReaderSummary } from '../../../lib/ctx/reader_summary'

export const ReaderSummaryText = ({ text }: { text: string }) => {
  const { colors } = useTheme()
  const feedback = useReaderSummary((s) => s.summaryFeedback)
  const isNegative = feedback === 'negative'

  return (
    <Text
      className={css`
        font-weight: 600;
        font-size: 17px;
        line-height: 22px;
        letter-spacing: -0.2px;
        padding: 0 20px;
        filter: blur(${isNegative ? 5 : 0}px);
        transition: filter ease-in-out 0.3s;
        will-change: filter;
        transform: translate3d(0, 0, 0);
      `}
      type="body"
      align="center"
      color={colors.uiWhite}
    >
      {text}
    </Text>
  )
}
